/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2021 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 *
 * @file ResourceCardView.jsx
 * @author Srinivasan Bakthavatchalam
 * @since 1.0.1
 */

import React, { memo } from 'react';
import PropTypes from 'prop-types';

import ResourceCard from './ResourceCard';

const ResourceCardView = ({
  bulkDownloadStatus,
  categoryItems,
  currentPageId,
  isFilterDropDownOpen,
  isPageLevel,
  onResourceClick,
  selectedResources,
  setSelectedResources,
  showDownload
}) => (
  <div className="resource-card-items">
    {categoryItems.map(
      (categoryItem, index) => (
        <ResourceCard
          bulkDownloadStatus={bulkDownloadStatus}
          currentPageId={currentPageId}
          isFilterDropDownOpen={isFilterDropDownOpen}
          isLastItem={index === (categoryItems.length - 1)}
          isPageLevel={isPageLevel}
          isSelected={selectedResources.some(resource => resource.id === categoryItem.id)}
          key={`${categoryItem.contentTypeValue}-${categoryItem.name}-${index}-${categoryItem.id}`}
          onResourceClick={onResourceClick}
          resourceItem={categoryItem}
          setSelectedResources={setSelectedResources}
          showDownload={showDownload}
        />))
}
  </div>);
ResourceCardView.propTypes = {
  bulkDownloadStatus: PropTypes.string.isRequired,
  categoryItems: PropTypes.array,
  currentPageId: PropTypes.array,
  isFilterDropDownOpen: PropTypes.bool.isRequired,
  isPageLevel: PropTypes.bool,
  onResourceClick: PropTypes.func.isRequired,
  selectedResources: PropTypes.array.isRequired,
  setSelectedResources: PropTypes.func.isRequired,
  showDownload: PropTypes.bool.isRequired
};
ResourceCardView.defaultProps = {
  categoryItems: [],
  currentPageId: [],
  isPageLevel: false
};

export default memo(ResourceCardView);
